import { apiMaybe } from '../../services/apiClient';

export function buildIntakeSearchQuery({ q, limit } = {}) {
  const params = new URLSearchParams();
  if (q != null && String(q).trim() !== '') params.set('q', String(q).trim());
  // The sessions endpoint takes a bare `limit` (it isn't paginated like the
  // contracts/reviews lists), so there's no page/pageSize translation here.
  if (limit) params.set('limit', String(limit));
  return params.toString();
}

/**
 * Quick-find over intake/screening sessions (used by ⌘K). Reuses the sessions
 * list endpoint's `q` filter — prospect/counterparty name, plus the owner's
 * name/email for legal/admin. The backend scopes results to the caller's own
 * intakes unless they are legal/admin, matching who may open the detail page,
 * so callers don't need any extra gating.
 */
export function searchIntakes(params = {}) {
  const query = buildIntakeSearchQuery(params);
  return apiMaybe(`/generate/sessions${query ? `?${query}` : ''}`);
}
